// extracted by mini-css-extract-plugin
module.exports = {"title":"SignUp_title__B0d2J","text":"SignUp_text__uJZz9","edit":"SignUp_edit__9D_EF","form":"SignUp_form__gfsSa","button":"SignUp_button__Wa_x1"};